import React, { useState } from 'react';
import {
  Avatar,
  Divider,
  Typography,
  Button,
  TextField,
  Grid,
  Stack,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import { useSelector, useDispatch } from 'react-redux';

import { listComments } from '../../../modules/chanceModule/chanceComments';
import * as chanceApi from '../../../lib/api/chance';
import EditorComponent from '../editor/EditorComponent';
import EditorViewComponent from '../editor/EditorViewComponent';

const ReplyComment = ({ comment, chance }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { user } = useSelector(({ auth }) => ({
    user: auth.user,
  }));

  const [edit, setEdit] = useState(false);
  const handleEdit = () => {
    setEdit(true);
    setCommentValue(comment.brdTxt);
  };

  const [commentValue, setCommentValue] = useState('');
  const handleEditorChange = (data) => {
    setCommentValue(data);
  };

  const onEdit = async () => {
    //수정
    try {
      comment.brdTxt = commentValue;
      const res = await chanceApi.editComment(comment);

      if (res.data) {
        setCommentValue('');
        dispatch(listComments(chance.prjUuid));
        setEdit(false);
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  const onRemove = async () => {
    try {
      const res = await chanceApi.removeComment(comment.brdUuid);

      if (res.data) {
        dispatch(listComments(chance.prjUuid));
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  return (
    <>
      <Divider variant="middle" sx={{ my: 2 }} />
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
      >
        <Grid
          item
          xs={3}
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item>
            {comment.profileImg ? (
              <Avatar alt={comment.crtNm} src={comment.profileImg} />
            ) : (
              <Avatar>{comment.crtNm.substring(0, 1)}</Avatar>
            )}
          </Grid>
          <Grid item>
            <Typography variant="body2">{comment.crtNm}</Typography>
          </Grid>
          <Grid item>
            <Typography variant="body2">{comment.crtDt}</Typography>
          </Grid>
        </Grid>
        <Grid
          item
          container
          xs={9}
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          <Grid
            item
            sx={{ width: '100%', minHeight: '50px', whiteSpace: 'pre-line' }}
          >
            {edit ? (
              <EditorComponent
                value={commentValue}
                onChange={handleEditorChange}
              />
            ) : (
              // <div dangerouslySetInnerHTML={{ __html: comment.brdTxt }}></div>
              <EditorViewComponent content={comment.brdTxt} />
            )}
          </Grid>
          <Grid
            item
            container
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
            sx={{
              px: 1,
            }}
          >
            <Stack direction="row" alignItems="center" spacing={1}>
              {user.usrUuid === comment.crtUsr && (
                <>
                  {!edit ? (
                    <>
                      <Button
                        size="small"
                        color="info"
                        variant="outlined"
                        onClick={handleEdit}
                      >
                        수정
                      </Button>
                    </>
                  ) : (
                    <>
                      <Button
                        size="small"
                        color="primary"
                        variant="contained"
                        onClick={onEdit}
                      >
                        저장
                      </Button>
                      <Button
                        size="small"
                        color="info"
                        variant="contained"
                        onClick={() => setEdit(false)}
                      >
                        취소
                      </Button>
                    </>
                  )}
                  <Button
                    size="small"
                    color="error"
                    variant="outlined"
                    onClick={onRemove}
                  >
                    삭제
                  </Button>
                </>
              )}
            </Stack>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default ReplyComment;
